<template>
	<div class="tutorial-item flip-card">
		<div class="flip-card-inner">
			<div class="flip-card-front">
				<h2>{{ codigo + 1 }}</h2>
				<h5>{{ title }}</h5>
			</div>
			<div class="flip-card-back">
				<h6>{{ text }}</h6>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex"

export default {
	name: "FlipCard",
	computed: {
		...mapState({
			parceiro: state => state.parceiro,
			parceiroConfig: state => state.parceiroConfig
		})
	},
	props: {
		codigo: Number,
		title: String,
		text: String
	}
}
</script>

<style lang="scss">
.flip-card {
	background-color: transparent;
	width: 250px;
	height: 300px;
	perspective: 1000px;
	h2 {
		color: var(--secondaryColor);
		font-size: 91px;
		font-family: "Montserrat-Bold";
	}
	h5 {
		color: var(--secondaryColor);
		font-size: 18px;
		font-family: "Montserrat-Bold";
		margin-bottom: 10px;
	}
	h6 {
		font-size: 16px;
		font-family: "Montserrat-Bold";
		color: var(--whiteColor);
	}
}

.flip-card-inner {
	position: relative;
	width: 100%;
	height: 100%;
	text-align: center;
	transition: transform 0.6s;
	transform-style: preserve-3d;
	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
	margin-left: 10px;
	margin-right: 10px;
	@media only screen and (max-width: 766px) {
		margin: 10px;
	}
	@media only screen and (max-width: 240px) {
		width: 200px;
	}
}

.flip-card:hover .flip-card-inner {
	transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
	position: absolute;
	width: 100%;
	height: 100%;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	align-items: center;
	padding: 15px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.flip-card-front {
	background-color: var(--whiteColor);
}

.flip-card-back {
	background-color: var(--primaryColor);
	color: white;
	transform: rotateY(180deg);
}
</style>